import React from "react";
import Menu from "./Menu";
import { ToastContainer } from "react-toastify";
import { Outlet } from "react-router-dom";
import Icon from "../ui/Icon";
import MenuHorizontal from "./MenuHorizontal";
import { ConfirmProvider } from "../../hooks/useConfirm";
import { useSidebar } from "../../hooks/useSideBar";

export function Layout(): JSX.Element {
  const { isCollapsed, toggleCollapse } = useSidebar();

  return (
    <>
      <ConfirmProvider>
        {/* Horizontal Menu */}
        <div className="w-full h-16">
          <MenuHorizontal />
        </div>

        {/* Main Layout */}
        <div className="flex h-[calc(100vh-4rem)] w-full">
          {/* Navbar */}
          <div
            className={`flex flex-col transition-all duration-300 justify-between
          ${isCollapsed ? "w-[60px]" : "w-[240px] "} 
          bg-gray-200 pt-4`}
          >
            <div>
              <Menu isCollapsed={isCollapsed} />
            </div>
            <div>
              <button
                className={`flex flex-row items-center text-black py-2 px-4 hover:bg-gray-300 
      transition duration-300 w-full h-10 ${isCollapsed ? "" : "justify-end"}`}
                onClick={toggleCollapse}
              >
                <div className="relative w-6 h-6">
                  <div
                    className={`absolute inset-0 transition-all duration-300 ease-in-out
          ${isCollapsed ? "opacity-100 transform scale-100" : "opacity-0 transform scale-50 rotate-180"}`}
                  >
                    <Icon icon="doubleSup" />
                  </div>
                  <div
                    className={`absolute inset-0 transition-all duration-300 ease-in-out
          ${!isCollapsed ? "opacity-100 transform scale-100" : "opacity-0 transform scale-50 -rotate-180"}`}
                  >
                    <Icon icon="doubleInf" />
                  </div>
                </div>
              </button>
            </div>
          </div>

          {/* Content Area */}
          <div
            className={`flex-1 transition-all duration-300 p-4 bg-gray-100 min-h-[calc(100vh-4rem)] 
          overflow-y-auto overscroll-contain`}
          >
            <Outlet />
            <ToastContainer />
          </div>
        </div>
      </ConfirmProvider>
    </>
  );
}
